import { createAsyncThunk } from "@reduxjs/toolkit";
import CAxios from "../utils/CAxios";
import { baseUrlApi } from "../../proxy";
import axios, { AxiosResponse } from "axios";

/*--------------------------GET PROGRAM REQUESTS-----------------------------*/
export const toGetProgramRequests = createAsyncThunk<
  any,
  {
    program_id?: number;
    limit?: number;
    page?: number;
    date_from?: string;
    date_to?: string;
  }
>("program/toGetProgramRequests", async (data) => {
  try {
    const response = await CAxios.post(`family/program/application`, data);
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});

export const toGetProgramsBeneficiary = createAsyncThunk<
  any,
  {
    tag: string;
    limit?: number;
    page?: number;
    date_to?: string;
    date_from?: string;
    category_id? : string;
  }
>("beneficiary/toGetProgramsBeneficiary", async (data) => {
  try {
    const response = await CAxios.post(`programs/beneficiary`, data);
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});

/*--------------------------GET ALL CATEGORIES-------------------------------------------*/
export const toGetProgramsCategories = createAsyncThunk(
  "beneficiary/toGetProgramsCategories",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}program/categories`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const toGetExternalPrograms = createAsyncThunk(
  "beneficiary/toGetExternalPrograms",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}programs/not_beneficiary`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const toGetCompletedExternalPrograms = createAsyncThunk<
  any,
  { category_id?: number; limit?: number; page?: number ;name? : string}
>("beneficiary/toGetCompletedExternalPrograms", async (data) => {
  try {
    const response = await axios.post(
      `${baseUrlApi}completed/programs/not_beneficiary`,
      data
    );
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});


export const toGetExternalProgramDetails = createAsyncThunk(
  "beneficiary/toGetExternalProgramDetails",
  async (access_token: string | undefined) => {
    try {
      const response = await axios.get(
        `${baseUrlApi}programs/not_beneficiary/${access_token}`
      );
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const toRegisterProgramExternalRequest = createAsyncThunk<
  AxiosResponse<any, any>,
  any
>("program/toRegisterProgramExternalRequest", async (programRequest) => {
  try {
    const response = await axios.post(
      `${baseUrlApi}programs/not_beneficiary/application`,
      programRequest,
      {
        headers: {
          "Accept-Language": "en",
        },
      }
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
});

export const toGetProgramFamilyByProgramId = createAsyncThunk<
  AxiosResponse<any, any>,
  any
>("beneficiary/toGetProgramFamilyByProgramId", async (programId) => {
  try {
    const response = await CAxios.post(`programs/beneficiaries`, programId);
    return response;
  } catch (error) {
    throw error;
  }
});

export const toAddProgramFamilyApplication = createAsyncThunk<
  AxiosResponse<any, any>,
  any
>("beneficiary/toAddProgramFamilyApplication", async (application) => {
  try {
    const response = await CAxios.post(
      `programs/beneficiary/application`,
      application
    );
    return response;
  } catch (error) {
    throw error;
  }
});
/*--------------------------Cancel PROGRAMS-----------------------------*/

//Add Sponsor Request
export const toCancelProgramRequest = createAsyncThunk<
  AxiosResponse<any, any>,
  any
>("program/toCancelProgramRequest", async (programRequest) => {
  try {
    const response = await CAxios.post(
      `programs/beneficiary/application/cancel`,
      programRequest
    );
    return response;
  } catch (error) {
    throw error;
  }
});
/*--------------------------GET ALL ACTIVITIES-------------------------------------------*/
export const toGetActivities = createAsyncThunk<
  any,
  {
    sponsor_id: number;
    orphan_id?: any;
    category_id?: any;
    limit?: number;
    page?: number;
    date_from?: string;
    date_to?: string;
  }
>("beneficiary/toGetActivities", async (data) => {
  try {
    const response = await CAxios.post(`sponsor/beneficiary/programs`, data);
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});

export const toGetProgramApplicationDetail = createAsyncThunk(
  "beneficiary/toGetProgramApplicationDetail",
  async (access_token?: string) => {
    try {
      const response = await CAxios.get(
        `program/application/not_beneficiary/` + access_token
      );
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
